<template>
    <div class="d-flex flex-column">
        <div>
            {{ props.text }}
        </div>
        <a v-if="props.link && props.linkText"
           class="link"
           :href="props.link"
           target="_blank">
            {{ props.linkText }}
        </a>
    </div>
</template>

<script setup lang="ts">
    interface Props {
        text: string;
        linkText?: string;
        link?: string;
    }
    const props = withDefaults(defineProps<Props>(), {
        linkText: '',
        link: '',
    });
</script>

<style scoped lang="scss">
    .link {
        padding-top: 8px;
    }

    .dark-theme {
        .link {
            text-decoration: underline;
        }
    }
</style>
